import React from 'react';
import GlobalLoader from '../common/GlobalLoader';

const LoadingScreen = () => {
  return <GlobalLoader message="Carregando painel..." />;
};

export default LoadingScreen;